import { gql } from "@apollo/client";

export const SEND_EMAIL_VERIFICATION = gql`
    mutation SendEmailVerification($email: String!) {
        sendEmailVerification(email: $email)
    }
`; 